export const ADD_MEDICAL_LEAVE = 'ADD_MEDICAL_LEAVE';
export const ADD_VACATION = 'ADD_VACATION';
export const ADD_SICK_LEAVE = 'ADD_SICK_LEAVE';
export const ADD_TIME_OFF = 'ADD_TIME_OFF';
export const SAVE_MEDICAL_LEAVES = 'SAVE_MEDICAL_LEAVES';
export const SAVE_VACATIONS = 'SAVE_VACATIONS';
export const SAVE_SICK_LEAVES = 'SAVE_SICK_LEAVES';
export const SAVE_TIME_OFF = 'SAVE_TIME_OFF';
export const FETCH_VACATIONS = 'FETCH_VACATIONS';
export const REMOVE_MEDICAL_LEAVE = 'REMOVE_MEDICAL_LEAVE';
export const REMOVE_VACATION = 'REMOVE_VACATION';
export const REMOVE_SICK_LEAVE = 'REMOVE_SICK_LEAVE';
export const REMOVE_TIME_OFF = 'REMOVE_TIME_OFF';
export const EDIT_SICK_LEAVE = 'EDIT_SICK_LEAVE';
export const EDIT_VACATION = 'EDIT_VACATION';
export const EDIT_TIME_OFF = 'EDIT_TIME_OFF';
export const EDIT_MEDICAL_LEAVE = 'EDIT_MEDICAL_LEAVE';
export const DELETE_MEDICAL_LEAVES = 'DELETE_MEDICAL_LEAVES';
export const DELETE_VACATIONS = 'DELETE_VACATIONS';
export const DELETE_SICK_LEAVES = 'DELETE_SICK_LEAVES';
export const DELETE_TIME_OFF = 'DELETE_TIME_OFF';
export const CLEAR_ALL_VACATIONS = 'CLEAR_ALL_VACATIONS';
export const FETCH_HOLIDAYS = 'employees/FETCH_HOLIDAYS';
export const ADD_HOLIDAY = 'employees/ADD_HOLIDAY';
export const DELETE_HOLIDAY = 'employees/DELETE_HOLIDAY';
export const SAVE_HOLIDAY = 'employees/SAVE_HOLIDAY';
export const EDIT_HOLIDAY = 'employees/EDIT_HOLIDAY';
export const CANCEL_EDIT_HOLIDAY = 'employees/CANCEL_EDIT_HOLIDAY';



// WEBPACK FOOTER //
// ./src/store/modules/vacation/mutation-types.js